"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const Containers_1 = require("components/styled/Containers");
const Grid_1 = require("components/styled/Grid");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const SignupForm_1 = require("components/styled/SignupForm");
const SocialIcons_1 = require("components/styled/SocialIcons");
const Text_1 = require("components/styled/Text");
const Wrapper = styled_components_1.default.div `
  ${ScreenSizes_1.TABLET_PORTRAIT} {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }
`;
const IconsWrapper = styled_components_1.default.div `
  margin-top: 20px;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin-top: 40px;
  }
`;
const TextWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    justify-content: flex-end;
  }
`;
const Img = styled_components_1.default.img `
  height: 20px;
`;
const Link = styled_components_1.default.a `
  text-decoration: none;
`;
exports.Footer = () => (React.createElement(Containers_1.FooterContainer, null,
    React.createElement(Containers_1.FooterContent, null,
        React.createElement(Grid_1.Row, null,
            React.createElement(Grid_1.Column, { width: 6, widthTablet: 5 },
                React.createElement(SignupForm_1.SignupForm, null)),
            React.createElement(Grid_1.Column, { width: 6, widthTablet: 3 },
                React.createElement(Wrapper, null,
                    React.createElement(IconsWrapper, null,
                        React.createElement(SocialIcons_1.SocialIcons, null)),
                    React.createElement(TextWrapper, null,
                        React.createElement(Img, { src: require(`../../img/heart-3x.png`) }),
                        React.createElement(Link, { target: "_blank", href: "https://www.stellar.org/" },
                            React.createElement(Text_1.FooterText, null, "Stellar.org")))))))));



// WEBPACK FOOTER //
// ./src/components/sections/Footer.tsx